import { combineReducers } from "redux";
import { reducer as oidcReducer } from "redux-oidc";

import {
  loginOIDCReducer,
  translationReducer,
  KYCReducers,
  ToolsReducers,
  AuthReducers,
  ApplicationsReducers,
  FormStepsReducer,
  StepperFormReducer,
  AppConfigReducer
} from "../Services";
import { languageReducer } from "../Local";

export const rootReducer = combineReducers({
  FormStepsReducer,
  translationReducer,
  KYCReducers,
  languageReducer,
  ToolsReducers,
  oidcReducer,
  loginOIDCReducer,
  AuthReducers,
  StepperFormReducer,
  ApplicationsReducers,
  AppConfigReducer
});
